import { api } from "@/lib/api";

const KEY = "obt_cookie_consent";
const loaded = {};

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const saveConsent = (c) => {
  const value = { necessary: true, analytics: !!c.analytics, marketing: !!c.marketing, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(value));
  window.dispatchEvent(new Event("obt-consent"));
  return value;
};

export const allowed = (settings, kind) => {
  if (!settings) return false;
  if (!settings.require_cookie_consent) return true;
  return !!getConsent()?.[kind];
};

const addScript = (src, inline) => {
  const s = document.createElement("script");
  if (src) {
    s.async = true;
    s.src = src;
  }
  if (inline) s.text = inline;
  document.head.appendChild(s);
};

const setMetaTag = (name, content) => {
  if (!content) return;
  const m = content.match(/content=["']([^"']+)["']/);
  const value = m ? m[1] : content.trim();
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const loadThirdParty = (settings) => {
  if (!settings) return;
  setMetaTag("google-site-verification", settings.gsc_verification);
  setMetaTag("facebook-domain-verification", settings.fb_domain_verification);
  if (allowed(settings, "analytics")) {
    if (settings.ga4_id && !loaded.ga) {
      loaded.ga = true;
      addScript(`https://www.googletagmanager.com/gtag/js?id=${settings.ga4_id}`);
      addScript(null, `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${settings.ga4_id}');`);
    }
    if (settings.gtm_id && !loaded.gtm) {
      loaded.gtm = true;
      addScript(null, `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${settings.gtm_id}');`);
    }
  }
  if (allowed(settings, "marketing")) {
    if (settings.facebook_pixel_id && !loaded.fb) {
      loaded.fb = true;
      addScript(null, `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${settings.facebook_pixel_id}');fbq('track','PageView');`);
    }
    if (settings.custom_head_scripts && !loaded.custom) {
      loaded.custom = true;
      document.head.appendChild(document.createRange().createContextualFragment(settings.custom_head_scripts));
    }
    if (settings.custom_footer_scripts && !loaded.footer) {
      loaded.footer = true;
      document.body.appendChild(document.createRange().createContextualFragment(settings.custom_footer_scripts));
    }
  }
};

export const fbEvent = (name, params) => {
  if (typeof window !== "undefined" && window.fbq) window.fbq("track", name, params || {});
};

const visitorId = () => {
  let id = localStorage.getItem("obt_vid");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("obt_vid", id);
  }
  return id;
};

const deviceInfo = () => {
  const ua = navigator.userAgent;
  const device = /tablet|ipad/i.test(ua) ? "tablet" : /mobi|android|iphone/i.test(ua) ? "mobile" : "desktop";
  const browser = /edg\//i.test(ua) ? "Edge" : /opr\//i.test(ua) ? "Opera" : /chrome|crios/i.test(ua) ? "Chrome" : /firefox|fxios/i.test(ua) ? "Firefox" : /safari/i.test(ua) ? "Safari" : "Other";
  return { device, browser };
};

let firstView = true;
export const trackPage = (settings) => {
  if (window.fbq && allowed(settings, "marketing")) {
    if (!firstView) window.fbq("track", "PageView");
  }
  firstView = false;
  if (!allowed(settings, "analytics")) return;
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => params.get(k) && (utm[k] = params.get(k)));
  api.post("/track", {
    url: window.location.href,
    path: window.location.pathname,
    title: document.title,
    visitor_id: visitorId(),
    referrer: document.referrer,
    utm,
    timestamp: new Date().toISOString(),
    ...deviceInfo(),
  }).catch(() => {});
  if (window.gtag && settings.ga4_id) window.gtag("event", "page_view", { page_path: window.location.pathname });
};
